import Icon from '../components/Icon.vue'

Icon.register({
  'book-reader': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M352 96c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96zM233.6 241.1c4.1 2.5 6.4 6.8 6.4 11.5v246c0 10.2-11.1 16.6-20.5 11.9-61-30.8-149.4-39.1-193-41.4-14.9-0.8-26.5-12.7-26.5-27v-222.8c0-15.6 13.5-28 29.8-27.1 48.4 2.8 144.5 12.7 203.8 49zM482.2 192.1c16.3-0.9 29.8 11.5 29.8 27.1v222.8c0 14.3-11.6 26.3-26.5 27.1-43.6 2.3-131.9 10.7-193 41.4-9.4 4.7-20.5-1.7-20.5-11.9v-245.8c0-4.7 2.3-9.1 6.4-11.6 59.3-36.3 155.4-46.3 203.8-49z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/book-reader.js
// module id = 677
// module chunks = 0